import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { DatePipe } from '@angular/common';
import { Announcement } from '../../models/announcement.model';
import { AnnouncementsService } from '../../services/announcements.service';
import { ToastService } from '../../services/toast.service';
import { DynamicContentViewerComponent } from '../../components/dynamic-content-viewer/dynamic-content-viewer.component';

@Component({
  selector: 'app-announcement-details',
  imports: [DatePipe, RouterLink, DynamicContentViewerComponent],
  templateUrl: './announcement-details.component.html',
  styles: `
    .card {
      --bs-card-border-radius: 0;
      --bs-card-inner-border-radius: 0;
    }
  `
})
export class AnnouncementDetailsComponent implements OnInit {
  announcement?: Announcement | null;
  announcements: Announcement[] = [];
  loading = true;

  private route = inject(ActivatedRoute);
  private announcementsService = inject(AnnouncementsService);
  private toast = inject(ToastService);
  private router = inject(Router);

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.getAnnouncement(params.get('id')!);
    });
  }

  getAnnouncement(id: string) {
    this.loading = true;
    this.announcement = null;

    this.announcementsService.get(id).subscribe({
      next: (res) => {
        this.announcement = res.data;
        this.getAnnouncements();
        this.loading = false;
      },
      error: (error) => {
        this.toast.error(error);
        this.router.navigateByUrl('/convocatorias');
        this.loading = false;
      }
    });
  }

  getAnnouncements() {
    this.announcementsService.getAll({ is_active: true }).subscribe((res) => {
      this.announcements = res.data.records
        .filter(
          (announcement: any) => announcement.id !== this.announcement?.id
        )
        .slice(0, 4);
    });
  }
}
